<template>
  <v-dialog width="800px" v-if="dialog" v-model="dialog" persistent>
    <v-card>
      <v-card-title>Assign to new taxonomy</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6">
              <v-select
                dense
                outlined
                v-model="family.id_family"
                :disabled="checkbox"
                label="Choose a family"
                :items="getTaxonFamiliesAll"
                item-text="family_name"
                item-value="id_family"
              >
              </v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-checkbox
                v-model="checkbox"
                dense
                label="I can't find the family in the previous list"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="12" v-if="checkbox">
              <v-text-field
                dense
                outlined
                v-model="family.family_name"
                label="Write here the name of the new family..."
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                dense
                outlined
                label="New taxon name"
                v-model="taxon.taxon_name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                dense
                outlined
                label="Pollen Habit"
                :items="getPollenHabits"
                item-value="id_pollen_habit"
                item-text="pollen_habit_code"
                v-model="taxon.id_pollen_habit"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12">
              <v-text-field
                dense
                outlined
                label="Plant habit"
                v-model="taxon.plant_habit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="closeNewTaxon">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="
            (!family.id_family && !family.family_name) ||
            !taxon.taxon_name ||
            !taxon.id_pollen_habit
          "
          @click="saveNewTaxon"
          ><v-icon left>mdi-content-save</v-icon>Save and close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "UnregisteredTaxonsNewTaxons",
  props: {
    dialog: {
      type: Boolean,
    },
    unregisteredTaxons: {
      type: Array,
    },
    selectedTaxon: {
      type: Array,
    },
    editedItem: {},
    editedIndex: {},
    close:{}
  },
  data() {
    return {
      checkbox: false,
      family: {
        id_family: null,
        family_name: "",
      },
      taxon: {
        taxon_name: "",
        plant_habit: "",
        id_pollen_habit: null,
      },
    };
  },
  methods: {
    ...mapActions(["addTaxon","addTaxonFamily","addAuthorTaxon2", "updateAuthorTaxon2"]),
    ...mapActions(["fetchTaxons", "fetchPollenHabits", "fetchTaxonFamilies"]),
    closeNewTaxon() {
      this.$emit("update:dialog", false);
      this.checkbox = false;
      this.family = Object.assign({}, this.defaultfamily);
      this.taxon = Object.assign({}, this.defaulttaxon);
    },
    async saveNewTaxon() {
      if (!this.family.id_family) {
        let rispfamily = await this.addTaxonFamily({
          family_name: this.family.family_name,
        });

        this.family.id_family = rispfamily.id_family;
      }

      let resptaxon = await this.addTaxon({
        taxon_name: this.taxon.taxon_name,
        id_family: this.family.id_family,
        id_pollen_habit: this.taxon.id_pollen_habit,
        plant_habit: this.taxon.plant_habit,
      });

      let newtaxon = {
        id_authortaxon: this.unregisteredTaxons[this.editedIndex].id_authortaxon,
        authortaxon_name: this.unregisteredTaxons[this.editedIndex].authortaxon_name,
        id_taxon: resptaxon.id_taxon,
        taxon_name: resptaxon.taxon_name,
        plant_habit: resptaxon.plant_habit,
        id_pollen_habit: resptaxon.id_pollen_habit,
        id_family: resptaxon.id_family,
        family_name: this.family.family_name,
      };

      if (!newtaxon.id_authortaxon) {
        let resp = await this.addAuthorTaxon2({
          authortaxon_name: newtaxon.authortaxon_name,
          id_taxon: newtaxon.id_taxon,
        });
        newtaxon.id_authortaxon = resp.id_authortaxon;
      } else {
        await this.updateAuthorTaxon2({
          id_authortaxon: newtaxon.id_authortaxon,
          id_taxon: newtaxon.id_taxon,
        });
      }

      this.unregisteredTaxons.splice(this.editedIndex, 1);
      this.fetchTaxons();
      this.fetchPollenHabits();
      this.fetchTaxonFamilies();
      this.checkbox = false;
      this.closeNewTaxon();
      this.$emit('close')
    },
  },
  computed: {
    ...mapGetters(["getPollenHabits", "getTaxonFamiliesAll"]),
  },
  watch: {
    checkbox(newval) {
      if (newval) {
        this.family.id_family = null;
      } else {
        this.family.family_name = null;
      }
    },
  },
};
</script>

<style>
</style>